/**
 * The minimal shape shared by org `Document`s and lead `LeadDocument`s so one
 * table can render either. The attachment URL lives in `file` on org documents
 * and in `fileUrl` (nullable) on lead documents — `attachmentUrl` collapses the
 * two.
 */
export interface DocumentsTableAttachment {
  id: string
  dateCreated?: string
  fileName: string
  fileSize: number
  file?: string
  fileUrl?: string | null
}

export interface DocumentsTableDocument {
  id: string
  dateCreated: string
  dateLastUploaded?: string | null
  documentType: string
  displayName: string
  parseStatus: string
  dateEffective: string | null
  dateExpiration: string | null
  /** Null on a pre-conversion lead document; renaming and Details need it. */
  org: string | null
  attachments: DocumentsTableAttachment[]
  metadata?: Record<string, unknown> | null
}

export function attachmentUrl(attachment: DocumentsTableAttachment): string | null {
  return attachment.fileUrl ?? attachment.file ?? null
}

/** Appends reuse the Document row, so dateCreated can predate the newest file. */
export function uploadedAt(document: DocumentsTableDocument): string {
  return document.dateLastUploaded ?? document.dateCreated
}

export function totalFileSize(document: DocumentsTableDocument): number | null {
  if (!document.attachments.length) return null
  return document.attachments.reduce((sum, attachment) => sum + attachment.fileSize, 0)
}
